import type { FeedbackPerspective } from './feedback-perspective'
import { compareMenonColors, type MenonColor } from './menon-color'
import type { Scale } from './scale'

export interface Skill {
  id: string
  title: string
  color: string
  image?: string
  pdf?: string
  shortDescription?: string
  mission?: string
  parentSkill?: Skill
}

export interface SkillReport {
  skill: Skill
  value: number | null
}

export interface DetailedSkillReport {
  skill: Skill
  average: number | null
  values: ReadonlyArray<number>
}

export interface SkillLabel {
  id: string
  title: string
  color: string
}

export interface SkillHistogramReport {
  skill: Skill
  scale: Scale
  reports: HistogramReport[]
}

export interface HistogramReport {
  perspective: FeedbackPerspective
  histogram: number[]
}

export interface RangeSkillReport {
  skill: Skill
  median: number
  deviation: number
  min: number
  max: number
  value: number
}

export const compareSkills = (a: Skill, b: Skill): number => {
  const aColor = a.color as MenonColor
  const bColor = b.color as MenonColor

  if (aColor && bColor) {
    return compareMenonColors(aColor, bColor)
  }
  return a.title.localeCompare(b.title)
}
